export default class QueryHaving {
	/** @param {any} having */
	constructor(having = undefined) {
		/** @type {'count'} */
		this.aggregate = having?.aggregate ?? 'count';

		/** @type {'none' | 'greater_or_equal' | 'between' | 'less_or_equal'} */
		this.operator = having?.operator ?? 'none';

		/** @type {number | number[]} */
		this.value = having?.value ?? 1;

		/** @type {number | null} */
		this.type = having?.type ?? null;
	}

	export() {
		return {
			aggregate: this.aggregate,
			operator:  this.operator,
			value:     this.value,
			type:      this.type,
		};
	}
}
